"use strict";

var _interopRequireWildcard = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.every.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.reduce.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.map.get-or-insert.js");
require("core-js/modules/es.map.get-or-insert-computed.js");
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ordersDispatches = require("@/api/orders-dispatches");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _index2 = require("@/utils/index");
var _index3 = _interopRequireDefault(require("@/components/Inr/index.vue"));
var _admins = require("@/api/admins");
var _agents = require("@/api/agents");
var _dealers = require("@/api/dealers");
var _admin = require("@/store/modules/admin");
var _states = require("@/api/locations/states");
var _cities = require("@/api/locations/cities");
var _index4 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _branchAgentService = require("@/services/branch-agent-service");
var _common = require("@/common");
var _moment = _interopRequireDefault(require("moment"));
var _roles = require("@/constants/roles.constants");
var XLSX = _interopRequireWildcard(require("xlsx"));
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.baseUrl = process.env.VUE_APP_BASE_API;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = false;
    this.downloadLoading = false;
    this.dateRange = '';
    this.branchListLoading = false;
    this.branchList = [];
    this.dialogVisible = false;
    this.isAgent = false;
    this.dispatchId = 0;
    this.agentList = [];
    this.agentUserList = [];
    this.dealerList = [];
    this.stateList = [];
    this.cityList = [];
    this.dealerListLoading = false;
    this.stateListLoading = false;
    this.cityListLoading = false;
    this.totalGrandTotal = '';
    this.assignedBranches = [] || null;
    this.salesExecutiveAdmins = [];
    this.zonalManagerAdmins = [];
    this.selectedColumns = [];
    this.showId = false;
    this.showDealerCode = false;
    this.showDealerCity = false;
    this.showDealerState = false;
    this.showBranchManagerAdmin = false;
    this.showSalesExecutiveAgent = false;
    this.showZonalManager = false;
    this.showFilters = false;
    this.seeCombinedReport = false;
    this.grandTotalSales = '';
    this.grandTotalPayments = '';
    this.grandTotalImpactValue = '';
    this.statusColorMap = {
      Pending: 'warning',
      'Request Approval': 'primary',
      Approved: 'success',
      Rejected: 'danger'
    };
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: undefined,
      adminId: undefined,
      agentId: undefined,
      agentUserId: undefined,
      stateId: undefined,
      cityName: undefined,
      startDate: undefined,
      endDate: undefined,
      applyBranchIdFilter: true,
      excludeBranches: false,
      'assignedAgents.id': undefined,
      "['mappedAdmin.id']": undefined,
      "['zonalAdmin.id']": undefined,
      branchId: [],
      sort: 'id,ASC',
      filter: {
        dealerId: '$eq',
        adminId: '$eq',
        agentId: '$eq',
        agentUserId: '$eq',
        stateId: '$eq',
        cityName: '$eq',
        branchId: '$in',
        'assignedAgents.id': '$eq',
        'mappedAdmin.id': '$eq',
        'zonalAdmin.id': '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.columnOptions = [{
      label: 'ID',
      key: 'ID'
    }, {
      label: 'Dealer Code',
      key: 'Dealer Code'
    }, {
      label: 'City',
      key: 'City'
    }, {
      label: 'State',
      key: 'State'
    }, {
      label: 'Sales Executive Agent',
      key: 'Sales Executive Agent'
    }, {
      label: 'Branch Manager',
      key: 'Branch Manager'
    }, {
      label: 'Zonal Manager',
      key: 'Zonal Manager'
    }];
    this.combinedOptions = [{
      label: 'Yes',
      key: true
    }, {
      label: 'No',
      key: false
    }];
    this.loggedInAdmin = null;
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = (0, _moment.default)();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = (0, _moment.default)([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = (0, _moment.default)([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = (0, _moment.default)();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = (0, _moment.default)([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = (0, _moment.default)([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
    this.getAdminByRole = (mappedAdmins, roleName) => {
      try {
        if (!mappedAdmins || !Array.isArray(mappedAdmins)) return 'N/A';
        // Find admin with the specified role
        const admin = mappedAdmins.find(admin => {
          var _admin$roles;
          return admin === null || admin === void 0 || (_admin$roles = admin.roles) === null || _admin$roles === void 0 ? void 0 : _admin$roles.some(role => (role === null || role === void 0 ? void 0 : role.name) === roleName);
        });
        return admin ? admin.fullName : 'N/A';
      } catch (err) {
        console.error(`Error processing ${roleName} admin:`, err);
        return 'Error';
      }
    };
  }
  isSalesExecutiveAdmin() {
    return (0, _common.isBranchManager)();
  }
  isZonalManagerAdmin() {
    return (0, _common.isZonalManager)();
  }
  onCheckboxChange(value) {
    this.listQuery.excludeBranches = value;
  }
  _isAdminRoles() {
    return (0, _common.isSuperAdmin)() || (0, _common.isAdmin)() || (0, _common.isReadOnly)();
  }
  async fetchSalesExecutiveManagers() {
    const allManagers = await (0, _admins.getAdmins)((0, _index2.getQuery)({
      enabled: true,
      adminsRoleId: [_roles.BRANCH_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.salesExecutiveAdmins = allManagers.data;
  }
  async fetchZonalAdminManagers() {
    const allManagers = await (0, _admins.getAdmins)((0, _index2.getQuery)({
      enabled: true,
      adminsRoleId: [_roles.ZONAL_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.zonalManagerAdmins = allManagers.data;
  }
  async activated() {
    try {
      // if (!this._isAdminRoles()) {
      this.listQuery.excludeBranches = true;
      // }
      // Assign branchId using BranchAgentService
      // this.listQuery.branchId = await BranchAgentService.assignBranchId();
      this.assignedBranches = await _branchAgentService.BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      // Fetch agents for the assigned branchId
      this.agentList = await _branchAgentService.BranchAgentService.fetchAgents(this.assignedBranches);
      // Fetch branches for non-super admin users
      this.branchList = await _branchAgentService.BranchAgentService.fetchBranches(this.assignedBranches);
      this.loggedInAdmin = _admin.AdminModule;
      // check if logged in user is Agent/Admin
      if (this.loggedInAdmin.userType === 'Agent') {
        this.isAgent = true;
        this.listQuery.agentId = this.loggedInAdmin.agentId;
        this.listQuery.agentUserId = this.loggedInAdmin.id;
        if (this.loggedInAdmin.roles.includes('Owner')) {
          this.listQuery.agentUserId = null;
        }
      }
      if (this.$route.query.startDate && this.$route.query.endDate) {
        this.dateRange = {
          start: this.$route.query.startDate,
          end: this.$route.query.endDate
        };
      }
      if (!this.dateRange) {
        await this.getCurrentFinancialYear();
      }
      this.listQuery = {
        ...this.listQuery,
        ...this.$route.query
      };
      this.fetchSalesExecutiveManagers();
      this.fetchZonalAdminManagers();
      // get dispatch list
      this.getList();
      this.getStateList();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  handleCombinedSelection() {
    this.getList();
  }
  async getList() {
    try {
      let data = null;
      this.listQuery = (0, _common.cleanListQuery)(this.listQuery);
      if (this.dateRange) {
        this.listQuery.startDate = this.dateRange.start;
        this.listQuery.endDate = this.dateRange.end;
      }
      if (!this.seeCombinedReport) {
        data = await (0, _ordersDispatches.dealerSalesReport)(this.listQuery);
        this.totalGrandTotal = data.sum;
        this.grandTotalPayments = null;
        this.grandTotalImpactValue = data.totalImpactValue; // ADD
      } else {
        data = await (0, _ordersDispatches.dealersCombinedReport)(this.listQuery);
        this.totalGrandTotal = data.grandTotalSales;
        this.grandTotalPayments = data.grandTotalPayments;
        this.grandTotalImpactValue = null; // ADD
      }
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getCurrentFinancialYear() {
    const dateData = await (0, _ordersDispatches.getFinancialYear)();
    this.dateRange = {
      start: dateData.startDate,
      end: dateData.endDate
    };
    this.listQuery.startDate = this.dateRange.start;
    this.listQuery.endDate = this.dateRange.end;
    // this.getList();
  }
  async downloadFax() {
    this.listLoading = true;
    try {
      const params = {};
      if (this.listQuery.adminId) {
        params.adminId = this.listQuery.adminId;
      }
      if (this.listQuery.agentId) {
        params.agentId = this.listQuery.agentId;
      }
      if (this.listQuery.dealerId) {
        params.dealerId = this.listQuery.dealerId;
      }
      if (this.listQuery.status) {
        params.status = this.listQuery.status;
      }
      if (this.dateRange) {
        params.startDate = this.dateRange.start;
        params.endDate = this.dateRange.end;
      }
      if (Object.keys(params).length) {
        const data = await (0, _ordersDispatches.generateFax)((0, _index2.getQuery)(params));
        window.open(data.url, '_blank');
        // const filename: string = "fax_" + new Date().getTime() + ".pdf";
        // this.downloadFile(data.url, filename);
      } else {
        this.$message({
          message: 'Please select atleast one filter',
          type: 'warning'
        });
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await (0, _dealers.searchDealers)(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getStateList(query = null) {
    try {
      this.stateList = await (0, _states.getStates)((0, _index2.getQuery)({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getCityList(stateId = 0) {
    try {
      this.cityListLoading = true;
      this.cityList = await (0, _cities.getCities)((0, _index2.getQuery)({
        enabled: true,
        stateId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          stateId: '$eq'
        }
      }));
      this.cityListLoading = false;
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getDealerCityList(params) {
    const data = await (0, _dealers.getDealerCities)(params);
    this.stateList = data.stateList;
    this.cityList = data.cityList;
  }
  async getAgentDealersList(params) {
    const data = await (0, _dealers.getAgentDealers)(params);
    // const data: any = await getAgentRoleWiseDealer(params);
    this.dealerList = data;
  }
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    } else {
      this.listQuery.startDate = undefined;
      this.listQuery.endDate = undefined;
    }
    if (this.listQuery.stateId) {
      this.showDealerState = true;
      this.showDealerCity = true;
      this.getCityList(this.listQuery.stateId);
    } else {
      // empty city
      this.showDealerState = false;
      this.showDealerCity = false;
      this.cityList = [];
      this.listQuery.cityId = undefined;
      this.listQuery.stateId = undefined;
    }
    if (!this.listQuery.cityId) {
      this.listQuery.cityId = undefined;
    }
    if (this.listQuery.dealerId) {
      const params = {
        dealerId: undefined
      };
      params.dealerId = this.listQuery.dealerId;
      this.getDealerCityList(params);
    }
    if (this.listQuery.agentId) {
      const params = {
        agentId: undefined
        // roles: undefined,
      };
      params.agentId = this.listQuery.agentId;
      // params.roles = AdminModule.roles;
      // this.getAgentDealersList(params);
    }
    if (this.listQuery.agentId) {
      const agentData = await (0, _agents.getAgentById)(this.listQuery.agentId);
      this.agentUserList = agentData.agentUser.filter(user => user.roles.some(role => role.name === 'Sales Executive'));
    }
    this.listQuery.page = 1;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!(0, _common.isSuperAdmin)() || !(0, _common.isAdmin)()) && ((_AdminModule$branchId = _admin.AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = _admin.AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      this.agentList = await _branchAgentService.BranchAgentService.fetchAgents(this.listQuery.branchId);
      await _branchAgentService.BranchAgentService.fetchBranches(this.listQuery.branchId);
      // Fetch the list after agents and branches are loaded
      this.getList();
    } else {
      // await this.handleClearBranch();
      this.getList();
    }
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop}` + (order === 'ascending' ? ',ASC' : ',DESC');
      this.handleFilter();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  toggleDialog(id = 0) {
    this.dialogVisible = true;
    this.dispatchId = id;
  }
  async downloadInvoice(id = 0) {
    // get invoice url
    this.listLoading = true;
    const url = await (0, _ordersDispatches.generateInvoice)(id);
    if (url) {
      window.open(url, '_blank');
      // const filename = "invoice_" + id + ".pdf";
      // this.downloadFile(data.url, filename);
    } else {
      this.$message({
        message: 'Failed to generate invoice',
        type: 'error'
      });
    }
    this.listLoading = false;
  }
  async appendManagerColumns(blob, allData) {
    const getRole = (mappedAdmins, roleName) => {
      if (!mappedAdmins || !Array.isArray(mappedAdmins)) return '';
      const admin = mappedAdmins.find(a => {
        var _a$roles;
        return a === null || a === void 0 || (_a$roles = a.roles) === null || _a$roles === void 0 ? void 0 : _a$roles.some(r => (r === null || r === void 0 ? void 0 : r.name) === roleName);
      });
      return admin ? admin.fullName : '';
    };
    const dealerMap = new Map();
    for (const row of allData) {
      const key = String(row.dealerName || row.dealer_name || row.dealer_id || '');
      if (key) dealerMap.set(key, row.mappedAdmins);
    }
    const arrayBuffer = await blob.arrayBuffer();
    const wb = XLSX.read(arrayBuffer, {
      type: 'array'
    });
    for (const sheetName of wb.SheetNames) {
      const ws = wb.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(ws, {
        header: 1
      });
      if (!data.length) continue;
      const headers = data[0];
      const dealerColIdx = headers.findIndex(h => ['Dealer', 'Dealer Name', 'dealer_name'].includes(String(h)));
      headers.push('Zonal Manager', 'Branch Manager');
      for (let i = 1; i < data.length; i++) {
        const row = data[i];
        const dealerKey = dealerColIdx >= 0 ? String(row[dealerColIdx] || '') : '';
        const admins = dealerMap.get(dealerKey);
        row.push(getRole(admins, 'Zonal Manager'));
        row.push(getRole(admins, 'Branch Manager'));
      }
      wb.Sheets[sheetName] = XLSX.utils.aoa_to_sheet(data);
    }
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });
    return new Blob([wbout], {
      type: 'application/octet-stream'
    });
  }
  async handleCombinedExcelDownload() {
    this.downloadLoading = false;
    try {
      const allQuery = {
        ...this.listQuery,
        page: 1,
        limit: 100000
      };
      const [blob, allDataResponse] = await Promise.all([(0, _ordersDispatches.downloadCombinedExcel)(this.listQuery), (0, _ordersDispatches.dealersCombinedReport)(allQuery)]);
      const modifiedBlob = await this.appendManagerColumns(blob, (allDataResponse === null || allDataResponse === void 0 ? void 0 : allDataResponse.data) || []);
      const url = window.URL.createObjectURL(modifiedBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'combined-report.xlsx';
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    }
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    this.listQuery = (0, _common.cleanListQuery)(this.listQuery);
    try {
      const queryWithoutPagination = {
        ...this.listQuery
      };
      delete queryWithoutPagination.page;
      delete queryWithoutPagination.limit;
      const allDataResponse = await (0, _ordersDispatches.dealerSalesReport)(queryWithoutPagination);
      let startDate;
      let endDate;
      if (this.listQuery.startDate && this.listQuery.endDate) {
        startDate = this.listQuery.startDate;
        endDate = this.listQuery.endDate;
      }
      const allData = allDataResponse.data;
      let grandTotal = allData.reduce((total, item) => total + +item.totalAmount, 0);
      if (grandTotal) {
        grandTotal = grandTotal.toFixed(2);
      } else {
        grandTotal = 0;
      }
      const query = this.listQuery;
      const blob = await (0, _ordersDispatches.downloadExcel)({
        query,
        grandTotal,
        startDate,
        endDate,
        applyBranchIdFilter: true
      });
      const modifiedBlob = await this.appendManagerColumns(blob, allData);
      const url = window.URL.createObjectURL(modifiedBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'sales-report.xlsx';
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    } finally {
      this.downloadLoading = false;
    }
  }
  getSummaries(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    const totalGrandTotalRow = [];
    columns.forEach((column, index) => {
      // first column
      if (index === 0) {
        sums[index] = 'Total Page Sales: ';
        totalGrandTotalRow[index] = 'Grand Total: '; // Add label for the total grand total row
        return;
      }
      // Grand Total column
      if (index === 9) {
        // get all values
        const values = data.map(item => Number(item[column.property]));
        // loop over & null check
        if (!values.every(value => isNaN(value))) {
          // sum them using reduce
          sums[index] = values.reduce((prev, curr) => {
            // value conversion (do check with Sandesh if toFixed something else required for decimal precision)
            const value = Number(curr);
            // null check
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0); // initial value
          // Calculate total grand total
          if (this.totalGrandTotal) {
            totalGrandTotalRow[index] = parseFloat(this.totalGrandTotal).toFixed(2);
          } else {
            totalGrandTotalRow[index] = 0;
          } // Store the totalGrandTotal value
        } // loop if ends
      } // index check ends
    }); // column loop ends
    // Return sums and total grand total row
    if (sums && sums.length) {
      if (sums[9]) {
        sums[9] = sums[9].toFixed(2);
      } else {
        sums[9] = 0;
      }
      //
    }
    const result = Array(9);
    result.push(sums, totalGrandTotalRow);
    return result; // Return both the sums and total grand total row
  }
  handleVisibleColumns(data) {
    this.showId = data.includes('ID');
    this.showDealerCode = data.includes('Dealer Code');
    this.showDealerCity = data.includes('City');
    this.showDealerState = data.includes('State');
    this.showSalesExecutiveAgent = data.includes('Sales Executive Agent');
    this.showBranchManagerAdmin = data.includes('Branch Manager');
    this.showZonalManager = data.includes('Zonal Manager');
  }
  get pageTotalSales() {
    if (!this.list || !this.list.length) return 0;
    if (this.seeCombinedReport) {
      return this.list.reduce((sum, item) => sum + +(item.totalsales || 0), 0);
    }
    return this.list.reduce((sum, item) => sum + +(item.totalAmount || 0), 0);
  }
  get pageTotalPayments() {
    if (!this.list || !this.list.length || !this.seeCombinedReport) return 0;
    return this.list.reduce((sum, item) => sum + Number(item.totalpayments || 0), 0);
  }
  get pageTotalImpactValue() {
    if (!this.list || !this.list.length || this.seeCombinedReport) return 0;
    return this.list.reduce((sum, item) => sum + Number(item.totalImpactValue || 0), 0);
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'SalesReportList',
  components: {
    Pagination: _index.default,
    Inr: _index3.default,
    Enabled: _index4.default
  }
})], default_1);
var _default = exports.default = default_1;